import mixpanel from "mixpanel-browser";
import axios from "../../Axios";
import { Constants, currentRequestTimeStamp } from "../../Constants";
import { ContextConstants } from "../../Context/AppContext";
import { Urls } from "../../Urls";
import { closeModal, hasValue } from "../../Utility";
import ActiveProcurementList from "./ActiveProcurementList";
import classes from "./Wizard.module.css";

export const getIcons = (path) => {
  let icons = "";
  switch (path) {
    case Constants.RoutePaths.GeneralInformation:
      icons = "far fa-user";
      break;
    case Constants.RoutePaths.BusinessProfile:
      icons = "far fa-map";
      break;
    case Constants.RoutePaths.OperationsOverview:
      icons = "fas  fa-signal";
      break;
    case Constants.RoutePaths.CustomerDetails:
      icons = "fas fa-book";
      break;
    case Constants.RoutePaths.ContractClosureInfo:
      icons = "fas fa-handshake";
      break;
    case Constants.RoutePaths.PreviewProfile:
      icons = "far fa-eye";
      break;
    case Constants.RoutePaths.Dashboard:
      icons = "far fa-bar-chart";
      break;
    case "/":
      icons = "fas fa-truck-moving";
      break;
    case "/generalInfo":
      icons = "fas fa-user";
      break;
    case "/businessProfile":
      icons = "fas fa-map";
      break;
    case "/operationsOverview":
      icons = "fas fa-signal";
      break;
    case "/customerDetails":
      icons = "fas fa-book";
      break;
    case "/contract":
      icons = "fas fa-handshake";
      break;
    case "/MyProfile":
      icons = "fas fa-eye";
      break;
    case "/dhandanow":
    case "/LaneIntelligence":
      icons = "fas fa-rupee-sign";
      break;
    case "/expression-of-interest":
      icons = "fas fa-rupee-sign";
      break;
    case "/tender":
      icons = "fas fa-rupee-sign";
      break;
    case "/enquiries":
      icons = "fas fa-truck-moving";
      break;
    case "/activeprocurement":
      icons = "fas fa-rupee-sign";
      break;
    case "/closedprocurement":
      icons = "fas fa-rupee-sign";
      break;
    case "/auction":
      icons = "fas fa-line-chart";
      break;
    case "/LocationIntelligence":
      icons = "fas fa-map-marker-alt";
      break;
    case "/trucks":
      icons = "fas fa-paste";
      break;
    case "/indents/requests":
      icons = "fas fa-tasks";
      break;
    case "/indents/invoice":
      icons = "fas fa-pencil-square";
      break;
    default:
      break;
  }
  return icons;
};

export const isGeneralInfoValid = (transporterInfo) => {
  return (
    hasValue(transporterInfo.transporter_name) &&
    hasValue(transporterInfo.headquarter)
  );
};

export const onLoaderStateChange = (dispatch) => {
  dispatch({
    type: ContextConstants.ToggleLoaderState,
  });
};

export const NavLink = ({
  id,
  history,
  onNavClick,
  path,
  title,
  style = {},
}) => (
  <div className={classes.link} style={{ ...style }}>
    <a
      onClick={() => {
        onNavClick(path);
      }}
      className={`${classes.button_color
        } d-flex align-items-center btn btn-sm btn-link pl-2 ${history.location.pathname === path ? classes["nav-active"] : ""
        }`}
      style={{ gap: "2px" }}
    >
      <span className={`pr-2`} style={{ width: "25px", height: "auto" }}>
        <i className={getIcons(path)} />
      </span>
      <span id={id} className={classes["link-text"]}>
        {title}
      </span>
    </a>
  </div>
);

export const initializeData = (data) => {
  if (!data["last_updated_by"]) {
    data["last_updated_by"] = [
      {
        contact_number: data["user_details"]["contact_number"],
        timestamp: new Date().toISOString(),
      },
    ];
  }

  let attachmentlist = [];
  // So it wont break
  if (!data.turnover || !data.turnover.length) {
    data["turnover"] = [{}];
  }

  if (!data.net_profit || !data.net_profit.length) {
    data["net_profit"] = [{}];
  }

  if (!data.owned_fleet) {
    data["owned_fleet"] = {};
  }

  if (!data.value_added_services || !data.value_added_services.length) {
    data["value_added_services"] = [];
  }

  if (!data.modes_of_transportation || !data.modes_of_transportation.length) {
    data["modes_of_transportation"] = [];
  }

  if (!data.bank_details) {
    data["bank_details"] = {};
  }
  if (!data.authSig_details) {
    data["authSig_details"] = {};
  }

  if (!data.acceptable_terms) {
    data["acceptable_terms"] = {};
  }

  if (!data.manpower_details) {
    data["manpower_details"] = {};
  }
  if (!data.percentage_completion) {
    data["percentage_completion"] = 0;
  }

  //For View
  if (!data.attachments || !data.attachments.length) {
    data["attachments"] = [
      { name: "profile" },
      { name: "branches" },
      { name: "operatingLanes" },
      { name: "warehousingHubs" },
      { name: "backhaulLanes" },
      { name: "other" },
    ];
  }

  if (data.attachments.length < 5) {
    data["attachments"] = [
      ...data["attachments"],
      { name: "backhaulLanes" },
      { name: "other" },
    ];
  }

  if (!data.contract_attachments || !data.contract_attachments.length) {
    data["contract_attachments"] = Constants.ContractAttachments;
  } else {
    if (data.contract_attachments.length !== 0) {
      for (var j = 0; j < data.contract_attachments.length; j++) {
        if (data.contract_attachments[j] === null) {
          data.contract_attachments.splice(j, 1);
        }
      }
      Constants.ContractAttachments.map((item) => {
        let found = false;
        for (let i = 0; i < data.contract_attachments.length; i++) {
          if (
            data.contract_attachments[i] === null ||
            data.contract_attachments[i] === undefined
          ) {
            continue;
          } else {
            let attachmentsItem = data.contract_attachments[i];
            if (attachmentsItem.name === item.name) {
              found = true;
              break;
            }
          }
        }
        if (!found) {
          attachmentlist.push(item);
        }
      });
      data["contract_attachments"] = [
        ...data.contract_attachments,
        ...attachmentlist,
      ];
      let removedOthersList = data.contract_attachments.filter(
        (item) => item.name !== "Others"
      );
      let lastOthersList = data.contract_attachments.filter(
        (item) => item.name === "Others"
      );
      data["contract_attachments"] = [...removedOthersList, ...lastOthersList];
    } else {
      data["contract_attachments"] = Constants.ContractAttachments;
    }
  }

  if (!data.modes_of_operation || !data.modes_of_operation.length) {
    data["modes_of_operation"] = [
      { name: "Contracted", percentage: "" },
      { name: "Spot/Walkin/Adhoc", percentage: "" },
    ];
  }

  if (!data.warehousing_services) {
    data["warehousing_services"] = { provideService: "", area: "", hubs: "" };
  }

  if (!data.gst) {
    data["gst"] = {};
  }

  if (!data.industry_served || !data.industry_served.length) {
    data["industry_served"] = [];
  }

  if (!data.shipment_tracking_method || !data.shipment_tracking_method.length) {
    data["shipment_tracking_method"] = [];
  }

  if (!data.company_details || !data.company_details.length) {
    data["company_details"] = [];
  }

  if (!data.customer_reference || !data.customer_reference.length) {
    data["customer_reference"] = [];
  }

  if (!data.contact_information || !data.contact_information.length) {
    data["contact_information"] = [];
  }
  if (!data.hand_over_status || data.hand_over_status) {
    data["hand_over_status"] = true;
  }

  return data;
};

export const onSave = async (transporterInfo, dispatch, callback, refetch) => {
  try {
    onLoaderStateChange(dispatch);
    await axios.post(Urls.Transporter.Post, transporterInfo);

    if (callback) callback();

    if (refetch) refetch();
  } catch (error) {
    console.error("Error saving transporter info:", error);
  } finally {
    onLoaderStateChange(dispatch);
  }
};

export const handleSideBarToggle = () => {
  const sidebar = document.getElementById("sidebar");
  if (sidebar.style.display === "none") {
    sidebar.style.display = "block"; // Or whatever the default display style should be
  } else {
    sidebar.style.display = "none";
  }
};

export const closeModalMenu = () => {
  closeModal("wizardMenu");
};

export const checkRoute = (path, isEditable) => {
  const allowedRoutes = [
    Constants.RoutePaths.GeneralInformation,
    Constants.RoutePaths.ContractClosureInfo,
    Constants.RoutePaths.BusinessProfile,
    Constants.RoutePaths.OperationsOverview,
    Constants.RoutePaths.CustomerDetails,
  ];

  if (allowedRoutes.includes(path)) {
    return true;
  }

  if (isEditable) {
    alert("Please click on save button to proceed.");
    return false;
  }

  return true;
};

export const sidebarJson = [
  {
    section: "LoRRI Profile",
    sectionIcon: "",
    expanded: true,
    items: [
      { label: "General Information", icon: "user", route: "/generalInfo" },
      { label: "Business Profile", icon: "map", route: "/businessProfile" },
      {
        label: "Operations Overview",
        icon: "chart-bar",
        route: "/operationsOverview",
      },
      {
        label: "Customer Details",
        icon: "file-text",
        route: "/customerDetails",
      },
      { label: "Contract Closure Info", icon: "handshake", route: "/contract" },
      { label: "Preview Profile", icon: "eye", route: "/MyProfile" },
      { label: "Dashboard", icon: "dashboard", route: "/dashboard" },
    ],
  },
  {
    section: "Live Tenders/RFQ",
    sectionIcon: "",
    expanded: true,
    items: [
      {
        label: "Active Tenders",
        icon: "inr",
        childComponent: <ActiveProcurementList />,
        route: "/activeprocurement",
      },
      { label: "Auction", icon: "gavel", route: "/auction" },
      {
        label: "Closed Tenders",
        icon: "inr",
        route: "/closedprocurement",
      },
    ],
  },
  {
    section: "Get New Business",
    sectionIcon: "",
    expanded: true,
    items: [
      {
        label: "Lane Intelligence",
        icon: "inr",
        route: "/dhandanow",
      },
      { label: "LoRRI Enquiries", icon: "file-alt", route: "/trucks" },
    ],
  },
  {
    section: "Indents",
    sectionIcon: "",
    expanded: true,
    items: [{ label: "Indents", icon: "table", route: "/indents" }],
  },
];

export const registerTransporterWithMixpanel = ({
  data,
  transporterContact,
  clientIp,
}) => {
  if (!data?.transporter_name || !data?.transporter_id) return;

  const poc = data?.contact_information?.find(
    (poc) => poc.contact_number === transporterContact
  );

  mixpanel.identify(data.transporter_name);
  mixpanel.register({
    user_id: data.transporter_id,
    user_name: data.transporter_name,
    user_contact: data.lsp_email,
    time: currentRequestTimeStamp(),
    IP: clientIp,
    poc_name: poc?.name,
    poc_contact: poc?.contact_number,
    poc_designation: poc?.designation,
    poc_email: poc?.email,
  });
};
